module.exports = __webpack_public_path__ + "media/images/star-off-6fdc47c656615e30acffa5d6b991bfc2.png";